import { configure, defineRule } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import { email, max, min, required } from '@vee-validate/rules'

// registerValidationRules wires the vee-validate rules used by App* inputs and localized messages.
export function registerValidationRules() {
    defineRule('required', required)
    defineRule('email', email)
    defineRule('min', min)
    defineRule('max', max)

    configure({
        generateMessage: localize({
            en: {
                messages: {
                    required: '{field} is required',
                    email: 'Invalid email',
                    min: '{field} is too short',
                    max: '{field} is too long',
                },
            },
            sl: {
                messages: {
                    required: '{field} je obvezno',
                    email: 'Neveljaven e-naslov',
                    min: '{field} je prekratko',
                    max: '{field} je predolgo',
                },
            },
        }),
    })

    setLocale(localStorage.getItem('locale') || 'sl')
}
